import ResponsiveCDNImage from "../../../components/common/image/responsive-cdn-image";
import heroGray from "../../../assets/images/hero_gray.png";
import type { GetReviewByStoreIdQuery } from "../../../__generated__/graphql";
import type { Review } from "../../../__generated__/graphql";

type PackReview =
  GetReviewByStoreIdQuery["getReviewByStoreId"][number];

interface PackReviewsProps {
  reviews: PackReview[];
  onReviewClick: (review: Review) => void;
}

const PackReviews = ({ reviews, onReviewClick }: PackReviewsProps) => {
  if (reviews.length === 0) return null;

  return (
    <div className="w-full bg-white">
      <div className="px-5 py-4">
        <div className="text-black text-lg font-semibold">
          📦 랜덤박스 미리보기
        </div>
        <div className="text-gray-500 text-sm mt-1">
          예약구매 리뷰가 표시돼요!
        </div>
      </div>
      <div className="px-5 pb-4">
        <div className="overflow-x-scroll flex gap-4">
          {reviews.slice(0, 10).map((review) => (
            <div
              key={review.id}
              onClick={() => onReviewClick(review as Review)}
              className="flex-shrink-0 w-[180px] h-[250px] rounded-lg border border-gray-200 relative overflow-hidden cursor-pointer hover:shadow-md transition-shadow"
            >
              {review.reviewImages && review.reviewImages.length > 0 ? (
                <ResponsiveCDNImage
                  src={review.reviewImages[0]?.img || ""}
                  alt="리뷰 이미지"
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full bg-gray-50 flex items-center justify-center">
                  <img
                    src={heroGray}
                    alt="리뷰 이미지"
                    className="w-full h-[100px] object-contain rounded-lg"
                  />
                </div>
              )}
              <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/90 to-transparent">
                <div className="flex items-center gap-1 mb-2">
                  <span className="font-semibold text-white text-sm">
                    {review.user?.maskedName}
                  </span>
                </div>
                <div className="text-white text-xs line-clamp-2">
                  {review.content}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PackReviews;
